import { useMemo } from "react";

import {
  faArrowTurnDownLeft,
  faCommand,
} from "@fortawesome/pro-regular-svg-icons";

import { useGlobalCommandbarStore } from "../../store";
import { CommandbarShortcutKeys } from "../../types/common";
import CommandbarShortcutIcon from "../ShortcutIcon";

export default function OpenInNewTab() {
  const shotcutKeysPressed = useGlobalCommandbarStore(
    st => st.shotcutKeysPressed,
  );
  const activeCommandbarItemId = useGlobalCommandbarStore(
    st => st.activeCommandbarItemId,
  );
  const commandbarSearchItems = useGlobalCommandbarStore(
    st => st.commandbarSearchItems,
  );
  const commandbarPageItems = useGlobalCommandbarStore(
    st => st.commandbarPageItems,
  );

  const activeItem = useMemo(() => {
    const allItems = [...commandbarSearchItems, ...commandbarPageItems];
    const item = allItems.find(
      item => item.id === activeCommandbarItemId && item.href,
    );

    return item;
  }, [activeCommandbarItemId, commandbarPageItems, commandbarSearchItems]);

  if (!activeItem) return null;

  const handleOpenInNewTab = () => {
    window.open(activeItem.href, "_blank");
  };

  return (
    <div
      className="flex items-center gap-2 cursor-pointer"
      onClick={handleOpenInNewTab}
    >
      <CommandbarShortcutIcon
        icon={faCommand}
        highlight={shotcutKeysPressed[CommandbarShortcutKeys.META]}
      />
      <CommandbarShortcutIcon
        icon={faArrowTurnDownLeft}
        highlight={shotcutKeysPressed[CommandbarShortcutKeys.ENTER]}
      />
      Open in new tab
    </div>
  );
}
